class AppStrings {
     //static IPAddress = "http://97.74.83.66:3002";
    //static IPAddress = "https://agnisofterp.in";
     static IPAddress = "https://scism.sakscodeit.com";
    static ReligonLink=this.IPAddress+'/agni/religion/detail';
    static ClassLink=this.IPAddress+"/agni/class/detail";
    static SectionLink=this.IPAddress+'/agni/section/detail';
    static GenderLink=this.IPAddress+'/agni/gender/detail';
    static AdmissionTypeLink=this.IPAddress+'/agni/addmission/detail';
    static StudentEntry=this.IPAddress+'/agni/student/entry';
    static StudentNewList=this.IPAddress+'/agni/student/addmission/detail';
    static FeesDetailGet=this.IPAddress+'/agni/fees/list';
    static BusStopList=this.IPAddress+'/agni/student/van/fees';
    static StudentFeesEntry=this.IPAddress+'/agni/student/fees/entry';
    static PendingFeeDetails=this.IPAddress+'/agni/pending/list';
    static OverAllStudentDetails=this.IPAddress+'/agni/overall/list';
    static BusDetails=this.IPAddress+'/agni/bus/detail';
    static VanFeesDetails=this.IPAddress+'/agni/student/van/fees'; 
    static StudentPromotionList=this.IPAddress+'/agni/student/promotion/list';
     static StudentPromotionEntry=this.IPAddress+'/agni/student/promotion/entry/alternate';
     static CollectionReport=this.IPAddress+'/agni/collection/detail';
     static StudentFeesPendingReport=this.IPAddress+'/agni/student/school/outstanding/detail';
     static DashboradList=this.IPAddress+'/agni/student/dashboard/list';
     static BusFeesEntry=this.IPAddress+'/agni/bus/entry';
     static TransportFeesPendingReport=this.IPAddress+'/agni/student/bus/outstanding/detail';
     static StudentPaymentHistory=this.IPAddress+'/agni/student/payment/history';
     static BillPrint=this.IPAddress+'/agni/prinit/detail';
     static FeesDiscount=this.IPAddress+'/agni/discount/detail';
     static CancelRefno=this.IPAddress+'/agni/student/cancel/entry';
     static AdditionalFee=this.IPAddress+'/agni/additional/fees/detail';
static AdditionalFeeSave=this.IPAddress+'/agni/student/fees/list/entry';
static GetStudentDetails=this.IPAddress+'/agni/student/detail';
static GetStudentFeesDetils=this.IPAddress+'/agni/student/payment/detail';
static AllFeesDetails=this.IPAddress+'/agni/student/fees/list';
static SaveToFeesDetails=this.IPAddress+'/agni/student/fees/entry2';
static PayModeList=this.IPAddress+'/agni/student/paymode/list';
static AdditionalFeeList=this.IPAddress+'/agni/student/additional/fees/detail';
static ReportList=this.IPAddress+'/agni/report/list';
static ReportHeaderList=this.IPAddress+'/agni/header/list/second';
static QryList=this.IPAddress+'/agni/qry/list';
static ReportQryListView=this.IPAddress+'/agni/customize/report';
static UserList=this.IPAddress+'/agni/user/list';
static UserCheck=this.IPAddress+'/agni/login';
static BonafideImageList=this.IPAddress+'/agni/bonafide/certificate/image';
static ReTransforStudent=this.IPAddress+'/agni/transfer/details';
static SMSSentLink=this.IPAddress+'/agni/sendsms';
static StaffEntry=this.IPAddress+'/agni/staff/entry';
static StaffEntryReport=this.IPAddress+'/agni/staff/details';
static SummaryReport=this.IPAddress+'/agni/summary/report';
static StaffStudentAssign=this.IPAddress+'/agni/staff/assign';
static StaffStudentAssignList=this.IPAddress+'/agni/staff/assign/details';
static SmsSent=this.IPAddress+'/agni/sms/list';
static SmsSentTo=this.IPAddress+'/agni/sms/send';
static UserNameAdd=this.IPAddress+'/agni/add/user';
static StdnOverAllPrint=this.IPAddress+'/agni/student/overallfees/print';

static FeesAddMaster=this.IPAddress+'/agni/fees/update';

static FeesUpdateMaster=this.IPAddress+'/agni/fees/update/list';





//static DeleteReportCuz=this.IPAddress+'/agni/login';



//static AllFeesList=this.IPAddress+'/agni/student/fees/list/entry';
     
      //    https://school.agnisofterp.com/agni/user/list
  }
  
  export default AppStrings;